<template>
    <VJoyWrapper class="rating-detail-item" direction="column" justify="flex-start" no-margin row-gap="2">
        <VJoyWrapper direction="row" no-margin justify="flex-start" column-gap="2">
            <VJoyIcon :name="icon" />
            <VJoyText preset="primary-350" tag-name="h3">
                {{ title }}
            </VJoyText>
        </VJoyWrapper>
        <VJoyWrapper direction="row" no-margin justify="flex-start" column-gap="2">
            <VJoyText preset="primary-350" tag-name="h3">
                {{ formatter.format(rating) }}
            </VJoyText>
            <VJoyRatingStars :rating-value="rating" />
        </VJoyWrapper>
    </VJoyWrapper>
</template>

<script setup lang="ts">
    import {VJoyIcon, VJoyRatingStars, VJoyText, VJoyWrapper} from '@maltjoy/core-vue';
    import type {JoyIconsId} from '@maltjoy/icons';
    import {useLocale} from '#build/imports';

    const {locale} = useLocale();

    type Props = {
        rating: number;
        icon: JoyIconsId;
        title: string;
    };
    defineProps<Props>();
    const formatter = new Intl.NumberFormat(locale.value, {minimumFractionDigits: 1, maximumFractionDigits: 1});
</script>
<style lang="scss" scoped>
    @use '@malt/joy-entrypoint' as joy;

    .rating-detail-item {
        align-items: center;
        @include joy.screen_xs(min) {
            align-items: flex-start;
        }
    }
</style>
